export const API_ROOT = 'https://cmsapi.zizbey.com/'
export const API_ROOT_DRONE = 'https://droneint.zizbey.com/'
